import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import CTAButton from '../shared/CTAButton';
import StickyInput from '../shared/StickyInput';
import { emailRegex } from '../../lib/constants/SiteVariables';

const type = 'email';
const label = 'Email Address';

export default function UserVerification({
  defaultValue,
  onSubmit,
  buttonText = 'Next',
}) {
  const [valid, setValid] = useState(false);
  const isLoading = false;

  return (
    <div role="form">
      <Formik
        initialValues={{
          contact: defaultValue,
        }}
        onSubmit={(values) => {
          onSubmit(values, type);
        }}
      >
        {({ values }) => (
          <Form>
            <div className="my-6">
              <StickyInput
                id="contact"
                name="contact"
                type="text"
                placeholder={label}
                mask={[
                  { ckType: 'unknown', mask: '*****' },
                  {
                    ckType: 'phone',
                    mask: '(999) 999-9999',
                    definitions: { 9: /\d/ },
                  },
                  { ckType: 'email', mask: /^\S*@?\S*$/gm },
                ]}
                values={values}
                dispatch={(appended, masked) => {
                  const typed = `${masked.value}${appended}`;
                  const newMask = masked.compiledMasks.find((m) => {
                    return m.ckType === type;
                  });

                  if (newMask.ckType === 'email') {
                    setValid(emailRegex.test(typed));
                  } else {
                    setValid(newMask.isComplete);
                  }

                  return newMask;
                }}
              />
            </div>
            <CTAButton
              ariaLabel="login-button"
              buttonClass="w-full bg-primary-blue text-white rounded-full py-3 px-6 cursor-pointer text-sm md:text-base inline-block hover:bg-navy-blue flex justify-center items-center"
              buttonText={buttonText}
              icon={['far', 'lock']}
              disabled={!valid || isLoading}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
}
